import { render, staticRenderFns } from "./_template-requirements-path.vue?vue&type=template&id=244741f8&"
import script from "./_template-requirements-path.vue?vue&type=script&lang=js&"
export * from "./_template-requirements-path.vue?vue&type=script&lang=js&"
import style0 from "./_template-requirements-path.vue?vue&type=style&index=0&id=244741f8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports